<template>
  <div id="app">
    <help-hub-header :env="currentEnv" @onHHComponentSuccess="onHHComponentSuccess"
      @onHHComponentError="onHHComponentError" :title="pageTitle"
      :log-mixpanel="currentEnv === 'DEV' || currentEnv === 'LOCAL'" />
    <div v-if="headerLoaded">
      <div class="title-wrapper"
        v-bind:class="{ 'hide-component': this.$router.currentRoute.name == 'easier-3-autodesk-software' }">
        <div class="container">
          <div class="title-container">
            <div class="row ml-1 align-items-center">
              <h1 class="app-page-title">Applications </h1>
              <employee-hub-bookmark :title="pageTitle" show-circle :blue-bookmark="true" class="mt-1" />
            </div>
            <div class="row ml-1">
              <p class="page-description">Find all the applications and sites that are available to you
              </p>
            </div>
          </div>
          <div class="search-container mt-2 mb-5 pr-3 pt-2">
            <div class="row">
              <div class="col-12">
                <search-filter :route="this.$router.currentRoute.name" />
              </div>
            </div>
          </div>
          You can find approved, commonly used products on the <a class="supplier-central-blurb"
          href="https://one.autodesk.com/apps/supplier-central/product-list" target="_blank">Supplier Central
          software access list</a>
        </div>
      </div>
      <div class="nav-wrapper">
        <div class="container">
          <nav class="navbar navbar-expand-lg navbar-light" v-if="getContentLoaded">
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
              aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation" ref="navbarToggler">
              <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse navbar-container" id="navbarNav">
              <ul class="navbar-nav nav-fill w-100 aad-nav">
                <li class="nav-item">
                  <router-link @click.native="clickRoute()" class="nav-link" to="/my-favorites">My
                    Favorites</router-link>
                </li>
                <li class="nav-item" v-for="view in getViews" :key="view.id">
                  <router-link @click.native="clickRoute()" class="nav-link"
                    :to="'/view/' + view.title | formatRouteName">{{ view.title }}</router-link>
                </li>
                <!-- <li class="nav-item">
                  <router-link @click.native="clickRoute()" class="nav-link" to="/downloads">Downloads</router-link>
                </li> -->
                <li class="nav-item">
                  <router-link @click.native="clickRoute()" class="nav-link" to="/all">All</router-link>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
      <div class="container parent-container">
        <loading-spinner v-if="!getContentLoaded"></loading-spinner>
        <div v-else>
          <alert-container></alert-container>
          <div class="view-container">
            <router-view />
          </div>
        </div>
      </div>
      <div class="footer">
        <help-hub-footer :env="currentEnv"></help-hub-footer>
      </div>
    </div>
    <loading-spinner v-else></loading-spinner>
  </div>
</template>
<script>
import api from '@/api';
import AlertContainer from "@/components/AlertContainer";
import LoadingSpinner from "@/components/LoadingSpinner";
import SearchFilter from "@/components/SearchFilter";
import axios from 'axios';
import Vue from 'vue';
import { mapGetters, mapMutations } from "vuex";
import * as CONSTANTS from "./constants.js";

export default {
  data() {
    return {
      CONSTANTS,
      currentEnv: process.env.VUE_APP_ENV,
      identityServiceId: process.env.VUE_APP_IDENTITY_SERVICE_ID,
      authToken: null,
      headerLoaded: false,
      pageTitle: 'Application and access dashboard'
    };
  },
  computed: {
    ...mapGetters(["getViewType", "getViews", "getContentLoaded"])
  },
  components: {
    AlertContainer,
    SearchFilter,
    LoadingSpinner
  },
  mounted() { },
  methods: {
    ...mapMutations(["setViewType", "setUser"]),
    clickRoute() {
      if (window.innerWidth < 992) {
        this.$refs.navbarToggler.click();
      }
    },
    setView(type) {
      this.setViewType(type);
    },
    onHHComponentSuccess(response) {
      response = response.detail[0];
      api.getApiInstance().defaults.headers.common.Authorization =
        "Bearer " + response.accessToken;
      this.authToken = response.accessToken;
      if (!this.headerLoaded) {
        this.setUser(response.user);
        this.$store.dispatch("initialize");
        this.headerLoaded = true;
        // mixpanel tracking
        var mixpanelInstance = response.mixpanelInstance
        mixpanelInstance.addRouterAutoTracking(this.$router);
        Vue.prototype.$hhMixpanel = mixpanelInstance;
      }
    },
    onHHComponentError(error) {
      console.log("Help Hub Header Error : ", error)
    }
  }
};
</script>
<style scoped>
.aad-nav a {
  padding: 11px;
}

.app-page-title {
  float: left;
  margin-right: 10px;
  font-size: 38px !important;
  line-height: 57px;
}

.title-wrapper {
  background-color: black;
  color: #ffffff;
  padding-top: 20px;
  padding-bottom: 15px;
}

.title-wrapper h1 {
  margin-bottom: 5px;
  font-size: 26px;
}

.title-wrapper p {
  font-size: 14px;
}

/** Navigation **/
.nav-wrapper {
  background-color: #f4f6f8;
}

.navbar-toggler {
  margin: 15px;
}

.navbar {
  padding: 0;
}

.navbar a {
  font-weight: bold;
  color: #575757;
}

.nav-tabs {
  border-bottom: none;
}

.nav-item .nav-text {
  font-size: 14px;
  margin-bottom: 5px;
}

.nav-item .nav-icon {
  font-size: 16px;
}

.nav-link {
  padding: 0.5rem;
}

.nav-tabs .nav-link {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.search-container {
  margin-bottom: 15px;
  max-width: 700px;
  font-size: 20px !important;
  font-family: "artifaktElementRegular";
  font-style: italic;
}

.view-select-container {
  float: right;
  margin-top: 10px;
}

.view-select-container span {
  margin: 5px;
  cursor: pointer;
}

.view-select-container span svg {
  height: 22px;
  width: 22px;
  color: #ababab;
}

.parent-container {
  background-color: #fff;
  min-height: 750px;
  margin-bottom: 75px;
}

.parent-container hr {
  margin-top: 0;
  margin-left: -15px;
  margin-right: -15px;
}

.view-container {
  margin-top: 25px;
}

.navbar a {
  font-size: 14px;
  font-weight: bold;
  color: #575757;
}

.router-link-active {
  color: var(--secondary-color) !important;
  border-bottom: 3px var(--secondary-color) solid;
}

.title-container {
  font-family: "artifaktElementBold";
}

.page-description {
  line-height: 30px;
  font-size: 20px !important;
  margin-bottom: 0;
}

.supplier-central-blurb {
  color: #ffffff !important;
  text-decoration: underline;
}

.supplier-central-blurb:hover,
.supplier-central-blurb:visited,
.supplier-central-blurb:active {
  color: #ffffff !important;
}

.hide-component {
  display: none;
}

.container {
  max-width: 1200px;
}

@media (max-width: 1200px) {

  .title-container h1,
  .title-container p,
  .search-container {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }

  .container {
    max-width: 100%;
    margin-right: unset;
    margin-left: unset;
  }

}
</style>
